import React, { useState } from "react";

// A member's round avatar (group chats): their BaseMap photo when they have one, else their initials.
const Avatar = ({ url, initials, name, className = '' }) => {
  const [broken, setBroken] = useState(false)
  return (
    <span className={`artemis-avatar ${className}`} title={name || ''}>
      {url && !broken
        ? <img src={url} alt="" onError={() => setBroken(true)} />
        : (initials || '?')}
    </span>
  )
}

export default Avatar
